import React, { memo, Suspense, useEffect } from "react";
import PropTypes from "prop-types";
import { useSearchBox, useInstantSearch, useConfigure } from "react-instantsearch";

import { useGtm } from "hooks";
import { ALGOLIA_STATUS } from "enums/algoliaStatus";

const SearchBoxGeneric = memo(
  ({
    headerSlot,
    emptySearchSlot,
    searchResultsSkeletonSlot,
    filtersSlot,
    resultsSlot,
    resultsSlotProps,
    inputSlot,
    initialQueryObject = {},
    loading,
    isSearch,
  }) => {
    const { status } = useInstantSearch();
    const { query: initialQuery } = initialQueryObject;
    const { query } = useSearchBox();
    useConfigure({});
    const isAlgoliaLoading = status === ALGOLIA_STATUS.LOADING || status === ALGOLIA_STATUS.STALLED;
    const { trackVirtualPageView } = useGtm();
    const Results = resultsSlot;

    useEffect(() => {
      if (!!initialQuery && query !== initialQuery && isSearch) {
        trackVirtualPageView({ name: "search", term: query });
      }
    }, [initialQuery, query]);

    return (
      <>
        {headerSlot}
        {inputSlot}
        {!query && emptySearchSlot}
        {filtersSlot}
        {Results ? (
          <Suspense fallback={<span />}>
            <Results
              searchTerm={query}
              {...resultsSlotProps}
              isLoading={isAlgoliaLoading || loading}
              isIdle={status === ALGOLIA_STATUS.IDLE}
              skeletonSlot={searchResultsSkeletonSlot}
            />
          </Suspense>
        ) : null}
      </>
    );
  },
);

SearchBoxGeneric.propTypes = {
  headerSlot: PropTypes.node,
  inputSlot: PropTypes.node,
  filtersSlot: PropTypes.node,
  emptySearchSlot: PropTypes.node,
  searchResultsSkeletonSlot: PropTypes.node,
  resultsSlot: PropTypes.elementType,
  resultsSlotProps: PropTypes.shape({}),
  initialQueryObject: PropTypes.shape({
    facetFilters: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    query: PropTypes.string,
  }),
  loading: PropTypes.bool,
  isSearch: PropTypes.bool,
};

SearchBoxGeneric.defaultProps = {
  loading: false,
  isSearch: false,
};

export default SearchBoxGeneric;
